import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import loginBackgroundImage from "../assets/login-bg-image.jpg";
import Logo from "../assets/EgaleEye_Logo.png";
import EagleILogo from "../assets/Eagle_I_Logo.png";
import TextField from "@material-ui/core/TextField";
import { styled } from "@mui/material/styles";
import { TypeAnimation } from "react-type-animation";
const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      color: "white",
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
  },
});
const styles = {
  floatingLabelFocusStyle: {
    color: "rgb(158, 158, 158)",
    margin: "auto",
  },
};

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const dummyUsers = [
    {
      username: "test",
      password: "test",
    },
    {
      username: "admin",
      password: "eagle@4321",
    },
    {
      username: "metofficer",
      password: "metofficer",
    },
    {
      username: "nbroofficer",
      password: "nbroofficer",
    },
    {
      username: "irrigationofficer",
      password: "irrigationofficer",
    },
    {
      username: "gaofficer",
      password: "gaofficer",
    },
    {
      username: "mvtest",
      password: "mvtest",
    },
  ];

  /* const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();

    const user = dummyUsers.find(
      (user) => user.username === username && user.password === password
    );

    if (user) {
      localStorage.setItem("user", JSON.stringify({ username: user.username }));
      navigate("/main-window");
    } else {
      setError("Invalid username or password");
    }
  }; */

  const handleLogin = () => {
    const user = dummyUsers.find(
      (u) => u.username === username && u.password === password
    );
  
    if (user) {
      const loginTime = new Date().toISOString();
      localStorage.setItem('accessToken', 'valid-token');
      localStorage.setItem('username', user.username);
      localStorage.setItem("loginTime", loginTime);
      window.location.href = '/eagle-I';
    } else {
      setError('Invalid username or password');
    }
  };

  /* const loginHandleClick = () => {
    navigate("/main-window");
  };
 */
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        margin: "auto auto",
        backgroundImage: `url(${loginBackgroundImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "2px",
          backgroundColor: "rgba(27, 18, 18, 0.6)", //42, 90, 156, 0.5 / 2, 101, 237, 0.5
          width: "50vw",
          height: "70vh",
        }}
      >
        <div
          style={{
            width: "45%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
          }}
        >
          <div>
            <div
              style={{
                width: "100%",
                display: "flex",
                fontSize: "22px",
                left: "0",
              }}
            >
              Login Here
            </div>
            <div>
              <CssTextField
                size="small"
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                //autoFocus
                InputLabelProps={{
                  style: styles.floatingLabelFocusStyle,
                }}
                inputProps={{ style: { color: "white" } }}
                style={{ width: "15vw" }}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div>
              <CssTextField
                size="small"
                variant="outlined"
                type="password"
                margin="normal"
                required
                fullWidth
                id="password"
                label="Password"
                name="password"
                //autoFocus
                InputLabelProps={{
                  style: styles.floatingLabelFocusStyle,
                }}
                inputProps={{ style: { color: "white" } }}
                style={{ width: "15vw" }}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div style={{ margin: "10px" }}>
              <button
                //onClick={() => {loginHandleClick()}}
                onClick={handleLogin}
                onTouchStart={handleLogin}
                style={{
                  height: "4.5vh",
                  width: "10vw",
                  border: "1px",
                  borderRadius: "5px",
                  color: "white",
                  backgroundColor: "#008F11",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Login
              </button>
            </div>
            {error && (
              <div>
                <p style={{ color: "red" }}>{error}</p>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            width: "60%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div style={{}}>
            <div style={{}}>
              <img
                src={EagleILogo /* Logo */}
                alt=""
                width={"250px"}
                height={"200px"}
              />
            </div>
            <div
              style={{
                height: "1.5em",
                fontSize: "1.5em",
                fontFamily: "'Proza Libre', sans-serif",
                color: "white",
                padding: "20px 0 0 0",
              }}
            >
              <TypeAnimation
                sequence={[500, "Welcome to Eagle-I", 500]}
                speed={40}
                //repeat={Infinity}
                cursor={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div
          style={{
            position: "absolute",
            bottom:  "10px",
            zIndex: 1,
            opacity: 0.5,
            color: "white",
            fontSize:"10px"
          }}
        >
      &copy; 2025 Tecxal Systems Pvt Ltd. All rights reserved.
        </div>
    </div>
  );
};
export default Login;
